import React, { useState } from 'react';
import { CurvedTopHeader } from '../../../../pages/v2/SelectYourPlan';
import becomeAProBg from '../../../../images/become-a-pro.png';
import { Button } from 'react-bootstrap';


const BecomeAPro = ({ handleSkip, handleGoPremium }) => {

  return (
    <>
      <CurvedTopHeader />
      <div className="mobile-become-a-pro-page">
        <div className="mobile-become-a-pro-heading">
          <h1 className="mobile-become-a-pro-title">
            Become a Pro Member Today
          </h1>
          <p className="mobile-become-a-pro-subtitle">
            Pro Members receive over <span className="underline">10x more opportunities</span> on average through Gitcha
          </p>
        </div>

        <div className="mobile-become-a-pro-image">
          <img src={becomeAProBg} alt="Pro vs Lite comparison" className="mobile-become-a-pro-img" />
        </div>

        <div className="mobile-become-a-pro-actions">
          <Button
            variant="primary"
            className="mobile-become-a-pro-btn"
            onClick={handleGoPremium}
          >
            Get Pro Member Benefits
          </Button>
          <Button
            variant="outline"
            className="mobile-become-a-pro-skip"
            onClick={handleSkip}
          >
            Skip
          </Button>
        </div>
      </div>
    </>
  );
};

export default BecomeAPro;